<template>
  <div></div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useAuthStore } from '@/store/auth'

const { redirectLogin } = useAuthStore()
const route = useRoute()
const router = useRouter()

onMounted(async () => {
  const isValidUser = await redirectLogin({
    accessToken: route.query.accessToken as string
  })
  if (isValidUser) {
    router.push({ name: 'board' })
  } else {
    router.push({ name: 'login' })
  }
})
</script>
